import React from 'react';
import { Path, Rect, SVG } from 'web-common/src/shared/design-system/Utilities';

interface BecomeAShefProps extends React.SVGProps<SVGSVGElement> {
  outline?: boolean;
}

export const BecomeAShef: React.FC<BecomeAShefProps> = ({ outline = false, ...props }) => {
  if (outline) {
    return <BecomeAShefOutline {...props} />;
  }

  return (
    <SVG width='24' height='24' viewBox='0 0 24 24' {...props}>
      <Rect x='8' y='2' width='2' height='3' />
      <Rect x='14' y='2' width='2' height='3' />
      <Path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M12 5C8 5 6 4 6 4L4 20.875C4 20.875 6 22 12 22C18 22 20 20.875 20 20.875L18 4C18 4 16 5 12 5ZM16 10C16 12.2091 14.2091 14 12 14C9.79086 14 8 12.2091 8 10H16Z'
      />
    </SVG>
  );
};

export const BecomeAShefOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <SVG width='24' height='24' viewBox='0 0 24 24' {...props}>
    <Path
      d='M6.846 5.36c.128.037.265.073.411.11C8.334 5.74 9.916 6 12 6c2.084 0 3.666-.26 4.742-.53.147-.037.284-.073.412-.11l1.762 14.867c-.225.07-.517.152-.886.235-1.167.262-3.092.538-6.03.538s-4.864-.276-6.03-.538c-.369-.083-.661-.165-.886-.235L6.846 5.36Z'
      stroke='currentColor'
      strokeWidth={2}
      fill='none'
    />
    <Path d='M8 2h2v3H8zM14 2h2v3h-2zM12 14a3 3 0 0 0 3-3H9a3 3 0 0 0 3 3Z' />
  </SVG>
);
